export default {
    props: {
      value: {
        twoWay: true,
        type: Array,
        default() {
          return []
        }
      },
      placeholder: {
        type: String,
        default: 'Nothing Selected'
      },
      multiple: {
        type: Boolean,
        default: false
      },
      limit: {
        type: Number,
        default: 1024
      }
    },
    data() {
      return {
        show: false,
        showNotify: false
      }
    },
    computed: {
      showPlaceholder() {
        return this.value.length <= 0
      }
    },
    watch: {
      value(val) {
        let timeout
        if (timeout) clearTimeout(timeout)
        if (val.length > this.limit) {
          this.showNotify = true
          this.value.pop()
          timeout = setTimeout(()=> this.showNotify = false, 1000)
        }
      }
    },
    methods: {
      toggleDropdown() {
        this.show = !this.show
      }
    }
  }


/** WEBPACK FOOTER **
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/Select.vue
 **/